import { combineReducers } from 'redux';
import { persistReducer, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import auth from './auth';

const persistConfig = {
  key :'root',
  storage,
  whitelist: ['auth']
}

const MainReducer = combineReducers({
  auth,
});

const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    state = undefined
  }
  return MainReducer(state, action);
}

export default persistReducer(persistConfig,rootReducer);
